import { render } from "./BusinessModelView.vue?vue&type=template&id=64309cfc"
import script from "./BusinessModelView.vue?vue&type=script&lang=js"
export * from "./BusinessModelView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__